module.exports = __webpack_public_path__ + "static/media/ninja-standing.4207cb8a.png";